module.exports = __webpack_public_path__ + "img/21exp.ae2f7a3e.jpg";